import React, { useState, useEffect }   from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import { useDispatch }                  from 'react-redux';

import { ErrorMessage }                 from '../../extras/toastMessages';
import { FISCALIA }                     from '../../../data/jurisdictions';
import { ICON_SEARCH, ICON_CANCEL }     from '../../extras/icons';
import { listAudiencesAction }          from '../../../actions/audiencesActions';

import audienceStates                   from '../../../data/audienceStates';
import ButtonSpinner                    from '../../layout/ButtonSpinner';
import clienteAxios                     from '../../../config/axios';



const FilterModal = props => {



    // --------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Tomo los props
    const { show, handleClose, initialPage, pageSize, setFilterParams, setFilters, filter, setFilter } = props;
    
    // Inicializo el dispatch
    const dispatch = useDispatch();
    
    // Inicializo el state local    
    const [ audienceTypes, setAudienceTypes ] = useState([]);
    const [ categorias, setCategorias ] = useState([]);
    const [ judges, setJudges ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ loadingParameters, setLoadingParameters ] = useState(false);
    const [ ofijus, setOfijus ] = useState([]);
    const [ operators, setOperators ] = useState([]);
    const [ parametersLoaded, setParametersLoaded ] = useState(false);
    const [ prosecutorOficces, setProsecutorOficces ] = useState([]);
    const [ selectedCategory, setSelectedCategory ] = useState('');
    const [ rooms, setRooms ] = useState([]);
    const [ units, setUnits ] = useState([]);
    


    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Manejo de cambios
    const handleChange = e => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        })
    }

    // Al inicio cargo los parámetros
    useEffect(() => {
        if (show && !parametersLoaded) {
            loadParameters();
        }
        //eslint-disable-next-line
    }, [show]);    
    // Hook para manejar selects relacionados Categorías > tipos
    useEffect(() => {
        if (show && (audienceTypes.length === 0 || filter.categoria !== selectedCategory) ) {
            loadAudienceTypeParameters();
            setSelectedCategory(filter.categoria);
        }
        //eslint-disable-next-line
    }, [filter.categoria, show]);    
    
    // Manejo la carga de parámetros
    const loadAudienceTypeParameters = async () => {
        try 
        {   //Tipos
            const responseAudienceTypes = await clienteAxios.get(`/audiencia-tipo?search=activo:1,categoria:${filter.categoria}&sort=descripcion:asc`);
            setAudienceTypes(responseAudienceTypes.data.content);
        } 
        catch (error) 
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    const loadParameters = async () => {
        try
        {   setLoadingParameters(true);
            //Fiscalia
            const responseProsecutorOffices = await clienteAxios.get(`/unidad?search=perfil.id:${FISCALIA}&sort=descripcion:asc`);
            setProsecutorOficces(responseProsecutorOffices.data.content);
            //Salas
            const responseRooms = await clienteAxios.get(`/sala?sort=descripcion:asc`);
            setRooms(responseRooms.data.content);
            //Jueces
            const responseJudges = await clienteAxios.get(`/juez?sort=apellido:asc,nombre:asc`);
            setJudges(responseJudges.data.content);
            //Solicitantes
            const responseUnits = await clienteAxios.get(`/unidad?search=perfil.id>1&sort=descripcion:asc`);
            setUnits(responseUnits.data.content);
            //Operadores
            const responseOperators = await clienteAxios.get(`/usuario?search=perfil.id:2,nivel.id:3&sort=apellido:asc,nombre:asc`);
            //Seteo los datos
            setOperators(responseOperators.data.content);
            //Ofijus
            const responseOfijus = await clienteAxios.get(`/ofiju?sort=nombre:asc`);
            setOfijus(responseOfijus.data.content);
            //Categorías
            const responseCategorias = await clienteAxios.get(`/categoria?search=grupo.id:null&sort=descripcion:asc`);
            setCategorias(responseCategorias.data.content);
            //Parametros Cargados correctamente
            setLoadingParameters(false);
            setParametersLoaded(true);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    // Manejo la búsqueda
    const handleSearch = e => {
        e.preventDefault();
        setLoading(true);

        const fp = {};
        const textFilter = [];

        if (filter.caratula && filter.caratula !== '') {
            fp.case_title = `contains:${filter.caratula}`;
            textFilter.push({ campo: 'carátula', valor: filter.caratula });
        }
        if (filter.categoria && filter.categoria.trim() !== '') {
            fp.category_id = `equals:${filter.categoria}`;
            const cat = categorias.find(c => c.id === filter.categoria);
            if (cat) textFilter.push({ campo: 'categoría', valor: cat.descripcion });
        }
        if (filter.estado && filter.estado.trim() !== '') {
            fp.status_id = `equals:${filter.estado}`;
            const st = audienceStates.find(as => as.id === filter.estado);
            if (st) textFilter.push({ campo: 'estado', valor: st.descripcion });
        }
        if (filter.fechaSolicitudDesde && filter.fechaSolicitudDesde !== '') {
            fp.request_date_from = `equals:${filter.fechaSolicitudDesde}`;
            textFilter.push({ campo: 'Fecha Solicitud Desde', valor: filter.fechaSolicitudDesde });
        }
        if (filter.fechaSolicitudHasta && filter.fechaSolicitudHasta !== '') {
            fp.request_date_to = `equals:${filter.fechaSolicitudHasta}`;
            textFilter.push({ campo: 'Fecha Solicitud Hasta', valor: filter.fechaSolicitudHasta });
        }
        if (filter.fechaInicioDesde && filter.fechaInicioDesde !== '') {
            fp.start_date_from = `equals:${filter.fechaInicioDesde}`;
            textFilter.push({ campo: 'Fecha Inicio Desde', valor: filter.fechaInicioDesde });
        }
        if (filter.fechaInicioHasta && filter.fechaInicioHasta !== '') {
            fp.start_date_to = `equals:${filter.fechaInicioHasta}`;
            textFilter.push({ campo: 'Fecha Inicio Hasta', valor: filter.fechaInicioHasta });
        }
        if (filter.fechaVencimientoDesde && filter.fechaVencimientoDesde !== '') {
            fp.detention_expiry_from = `equals:${filter.fechaVencimientoDesde}`;
            textFilter.push({ campo: 'Vencimiento de medida Desde', valor: filter.fechaVencimientoDesde });
        }
        if (filter.fechaVencimientoHasta && filter.fechaVencimientoHasta !== '') {
            fp.detention_expiry_to = `equals:${filter.fechaVencimientoHasta}`;
            textFilter.push({ campo: 'Vencimiento de medida Hasta', valor: filter.fechaVencimientoHasta });
        }
        if (filter.vencimientoIPPDesde && filter.vencimientoIPPDesde !== '') {
            fp.investigation_expiry_from = `equals:${filter.vencimientoIPPDesde}`;
            textFilter.push({ campo: 'Vencimiento IPP Desde', valor: filter.vencimientoIPPDesde });
        }
        if (filter.vencimientoIPPHasta && filter.vencimientoIPPHasta !== '') {
            fp.investigation_expiry_to = `equals:${filter.vencimientoIPPHasta}`;
            textFilter.push({ campo: 'Vencimiento IPP Hasta', valor: filter.vencimientoIPPHasta });
        }
        if (filter.fiscalia && filter.fiscalia !== '') {
            fp.prosecution_office_id = `equals:${filter.fiscalia}`;
            const po = prosecutorOficces.find(p => p.id === filter.fiscalia);
            if (po) textFilter.push({ campo: 'Fiscalía', valor: po.descripcion });
        }
        if (filter.id && filter.id !== '' && !isNaN(filter.id)) {
            fp.id = `equals:${filter.id}`;
            textFilter.push({ campo: 'ID', valor: filter.id });
        }
        if (filter.juez && filter.juez.trim() !== '') {
            fp.judge_id = `equals:${filter.juez}`;
            const j = judges.find(jj => jj.id === filter.juez);
            if (j) textFilter.push({ campo: 'juez', valor: `${j.apellido}, ${j.nombre}` });
        }
        if (filter.numero && filter.numero !== '') {
            fp.file_number = `contains:${filter.numero}`;
            textFilter.push({ campo: 'legajo', valor: filter.numero });
        }
        if (filter.ofiju && filter.ofiju.trim() !== '') {
            fp.judicial_office_id = `equals:${filter.ofiju}`;
            const of_ = ofijus.find(o => o.id === filter.ofiju);
            if (of_) textFilter.push({ campo: 'ofiju', valor: of_.nombre });
        }
        if (filter.operador && filter.operador.trim() !== '') {
            fp.operator_id = `equals:${filter.operador}`;
            const op = operators.find(o => o.id === filter.operador);
            if (op) textFilter.push({ campo: 'operador', valor: `${op.apellido}, ${op.nombre}` });
        }
        if (filter.sala && filter.sala.trim() !== '') {
            fp.room_id = `equals:${filter.sala}`;
            const r = rooms.find(r => r.id === filter.sala);
            if (r) textFilter.push({ campo: 'sala', valor: r.descripcion });
        }
        if (filter.solicitante && filter.solicitante.trim() !== '') {
            fp.requester_id = `equals:${filter.solicitante}`;
            const u = units.find(u => u.id === filter.solicitante);
            if (u) textFilter.push({ campo: 'solicitante', valor: u.descripcion });
        }
        if (filter.tipo && filter.tipo.trim() !== '') {
            fp.type_id = `equals:${filter.tipo}`;
            const at = audienceTypes.find(t => t.id === filter.tipo);
            if (at) textFilter.push({ campo: 'tipo', valor: at.descripcion });
        }

        setFilterParams(fp);
        setFilters(textFilter);
        dispatch(listAudiencesAction({ page: initialPage, size: pageSize, ...fp }));
        handleClose();
        setLoading(false);
    }
    
    
    
    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <Modal 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleClose } 
            show = { show } 
            size = "lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Filtrar Audiencias
                </Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSearch} autoComplete="off">
                <Modal.Body>
                    {   loadingParameters ? (
                            <div className="text-center py-4">
                                <Spinner animation="border" variant="primary" />
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Complete los campos por los que desea filtrar, luego presione el botón <strong>BUSCAR</strong> <ICON_SEARCH />
                                    </div>
                                </div>
                                <Form.Group className="col-md-3">
                                    <Form.Label>Fecha Solicitud Desde:</Form.Label>
                                    <Form.Control
                                        id = "fechaSolicitudDesde"
                                        className = "form-control" 
                                        autoFocus 
                                        name = "fechaSolicitudDesde" 
                                        type = "date" 
                                        placeholder = "Fecha Solicitud Desde"
                                        value = { filter.fechaSolicitudDesde }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <Form.Label>Fecha Solicitud Hasta:</Form.Label>
                                    <Form.Control
                                        id = "fechaSolicitudHasta"
                                        className = "form-control" 
                                        name = "fechaSolicitudHasta" 
                                        type = "date" 
                                        placeholder = "Fecha Solicitud Hasta"
                                        value = { filter.fechaSolicitudHasta }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <Form.Label>Fecha Inicio Desde:</Form.Label>
                                    <Form.Control
                                        id = "fechaInicioDesde"
                                        className = "form-control" 
                                        name = "fechaInicioDesde" 
                                        type = "date" 
                                        placeholder = "Fecha Inicio Desde"
                                        value = { filter.fechaInicioDesde }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <Form.Label>Fecha Inicio Hasta:</Form.Label>
                                    <Form.Control
                                        id = "fechaInicioHasta"
                                        className = "form-control" 
                                        name = "fechaInicioHasta" 
                                        type = "date" 
                                        placeholder = "Fecha Inicio Hasta"
                                        value = { filter.fechaInicioHasta }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <Form.Label>Vencimiento de medida Desde:</Form.Label>
                                    <Form.Control
                                        id = "fechaVencimientoDesde"
                                        className = "form-control"
                                        name = "fechaVencimientoDesde"
                                        type = "date"
                                        value = { filter.fechaVencimientoDesde }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <Form.Label>Vencimiento de medida Hasta:</Form.Label>
                                    <Form.Control
                                        id = "fechaVencimientoHasta"
                                        className = "form-control"
                                        name = "fechaVencimientoHasta"
                                        type = "date"
                                        value = { filter.fechaVencimientoHasta }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <Form.Label>Vencimiento de IPP Desde:</Form.Label>
                                    <Form.Control
                                        id = "vencimientoIPPDesde"
                                        className = "form-control"
                                        name = "vencimientoIPPDesde"
                                        type = "date"
                                        value = { filter.vencimientoIPPDesde }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <Form.Label>Vencimiento de IPP Hasta:</Form.Label>
                                    <Form.Control
                                        id = "vencimientoIPPHasta"
                                        className = "form-control"
                                        name = "vencimientoIPPHasta"
                                        type = "date"
                                        value = { filter.vencimientoIPPHasta }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <Form.Label>&nbsp;</Form.Label>
                                    <Form.Control
                                        id = "numero"
                                        className = "form-control"
                                        name = "numero"
                                        type = "text"
                                        placeholder = "Nro. Legajo"
                                        value = { filter.numero }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <Form.Label>&nbsp;</Form.Label>
                                    <Form.Control
                                        id = "id"
                                        className = "form-control"
                                        name = "id"
                                        type = "text"
                                        placeholder = "ID Audiencia"
                                        value = { filter.id }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <Form.Label>&nbsp;</Form.Label>
                                    <Form.Control
                                        as = "select"
                                        id = "estado"
                                        className = "form-control"
                                        name = "estado"
                                        value = { filter.estado }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    >
                                        <option value="">Todos los Estados</option>
                                        {   audienceStates.map(audienceState => (
                                                <option value={audienceState.id} key={`fmas${audienceState.id}`}>
                                                    { audienceState.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        id = "caratula"
                                        className = "form-control" 
                                        name = "caratula" 
                                        type = "text" 
                                        placeholder = "Carátula"
                                        value = { filter.caratula }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as = "select"
                                        id = "fiscalia"
                                        className = "form-control"  
                                        name = "fiscalia"  
                                        value = { filter.fiscalia }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    >
                                        <option value="">Todas las Fiscalías</option>
                                        {   prosecutorOficces.map(prosecutorOficce => (
                                                <option value={prosecutorOficce.id} key={`fmpo${prosecutorOficce.id}`}>
                                                    { prosecutorOficce.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as = "select"
                                        id = "ofiju"
                                        className = "form-control"  
                                        name = "ofiju"  
                                        value = { filter.ofiju }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    >
                                        <option value="">Todas las Ofijus</option>
                                        {   ofijus.map(ofiju => (
                                                <option value={ofiju.id} key={`fmj${ofiju.id}`}>
                                                    { ofiju.nombre }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as = "select"
                                        id = "sala"
                                        className = "form-control"
                                        name = "sala"
                                        value = { filter.sala }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    >
                                        <option value="">Todos las Salas</option>
                                        {   rooms.map(room => (
                                                <option value={room.id} key={`fms${room.id}`}>
                                                    { room.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as = "select"
                                        id = "operador"
                                        className = "form-control"
                                        name = "operador"
                                        value = { filter.operador }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    >
                                        <option value="">Todos los Operadores</option>
                                        {   operators.map(operator => (
                                                <option value={operator.id} key={`fmo${operator.id}`}>
                                                    { operator.apellido + ', ' + operator.nombre }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as = "select"
                                        id = "solicitante"
                                        className = "form-control"  
                                        name = "solicitante"  
                                        value = { filter.solicitante }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    >
                                        <option value="">Todos los Solicitantes</option>
                                        {   units.map(unit => (
                                                <option value={unit.id} key={`fms${unit.id}`}>
                                                    { unit.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>                        
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as = "select"
                                        id = "juez"
                                        className = "form-control"  
                                        name = "juez"  
                                        value = { filter.juez }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    >
                                        <option value="">Todos los Jueces</option>
                                        {   judges.map(judge => (
                                                <option value={judge.id} key={`fmj${judge.id}`}>
                                                    { judge.apellido + ', ' + judge.nombre }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as = "select"
                                        id = "categoria"
                                        className = "form-control"  
                                        name = "categoria"  
                                        value = { filter.categoria }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    >
                                        <option value="">Todas las Categorías</option>
                                        {   categorias.map(categoria => (
                                                <option value={categoria.id} key={`fmat${categoria.id}`}>
                                                    { categoria.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as = "select"
                                        id = "tipo"
                                        className = "form-control"  
                                        name = "tipo"  
                                        value = { filter.tipo }
                                        onChange = { handleChange }
                                        disabled = { loading }
                                    >
                                        <option value="">Todos los Tipos</option>
                                        {   audienceTypes.map(audienceType => (
                                                <option value={audienceType.id} key={`fmat${audienceType.id}`}>
                                                    { audienceType.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </div>
                        ) 
                    }
                </Modal.Body>
                <Modal.Footer>
                    {   loading 
                            ?
                                <ButtonSpinner />
                            :
                                <Button variant="primary" type="submit" disabled={ loading }>
                                    <ICON_SEARCH /> <strong>BUSCAR</strong>
                                </Button>
                    }
                    <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                        <ICON_CANCEL /> Cancelar
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default FilterModal;
